import { render, staticRenderFns } from "./FileUploadView.vue?vue&type=template&id=18fc7b17&scoped=true&"
import script from "./FileUploadView.vue?vue&type=script&lang=js&"
export * from "./FileUploadView.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadView.vue?vue&type=style&index=0&id=18fc7b17&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fc7b17",
  null
  
)

export default component.exports